import { LinkButton } from '@cian/ui-kit';
import * as classNames from 'classnames';
import * as React from 'react';

import * as styles from './SearchBlock.css';

interface ISearchBlockProps {
  text: string;
  placeholder?: string;
  onSearchClick(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const SearchBlock: React.FC<ISearchBlockProps> = ({
  onSearchClick,
  text,
  placeholder = 'Что вам интересно?',
}) => {
  return (
    <div className={styles['container']}>
      <a
        href="/nd/search/"
        className={classNames(styles['button'], styles['geo-button'], !text && styles['placeholder'])}
        onClick={onSearchClick}
      >
        {text || placeholder}
      </a>
      <LinkButton href="/nd/search/" size="M" onClick={onSearchClick}>
        Поиск
      </LinkButton>
    </div>
  );
};
